import React from 'react'

export default (
  <svg
    height="512"
    viewBox="0 0 512 512"
    width="512"
    fill="none"
    stroke="none"
    strokeWidth="32"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    // style={{ backgroundColor: 'black' }}
  >
    <title />
    <path d="M256 370.43 L96 279 L96 377.42 L256 466.3 L416 377.42 L416 279 Z" />
    <path d="M512.25 192 L256 45.57 L-0.25 192 L256 338.43 L464 219.57 L464 384 L512 384 L512 192.14 Z" />
  </svg>
)
